import { h } from 'preact'
import Icon from '../assets'
import TeamNotesLastEdited from './TeamNotesLastEdited'

type Props = {
  updatedBy: string,
  updatedAt: string,
  isLoading: boolean
}

const TeamNotesMetadata = ({ updatedBy, updatedAt, isLoading } : Props) => (
  <div class='team-notes__metadata'>
    <div>
      <Icon
        icon='lock'
        width={16}
        height={16}
      />
      <div class='team-notes__metadata-visibility'>Only visible in control</div>
    </div>
    {updatedAt
      ? <TeamNotesLastEdited
        updatedBy={updatedBy}
        updatedAt={updatedAt}
        isLoading={isLoading}
      />
      : null
    }
  </div>
)

export default TeamNotesMetadata
